import React, { useEffect, useState } from 'react'
import not from './image/notrans .png'
import nogame from './image/nogame.png'

import './App.css'
import { Api_Url } from './APIUrl'
import { useNavigate } from 'react-router-dom'


const TransactionHistory = () => {
    const [activeTab, setActiveTab] = useState("Payment");
     const [Data, setData] = useState([]);
     const [game, setGame] = useState([]);

    const handleTabClick = (tab) => {
      setActiveTab(tab);
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString); // Convert string to Date object
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear().toString().slice(-2); // Extract last 2 digits of the year
      return `${day}/${month}/${year}`;
    };

    const GetDepositApi =()=>{
      try {
        const myHeaders = new Headers();
myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

const requestOptions = {
  method: "GET",
  headers: myHeaders,
  redirect: "follow"
};

fetch(`${Api_Url}api/deposit`, requestOptions)
  .then((response) => response.json())
  .then((result) => {
    if(result.success == true){
      setData(result.data.qrcodes)
    }
  })
  .catch((error) => console.error(error));

      } catch (error) { 
      }
    }




    const GetGameTrans = ()=>{
      try {
        const myHeaders = new Headers();
myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

const requestOptions = {
  method: "GET",
  headers: myHeaders,
  redirect: "follow"
};

fetch(`${Api_Url}api/game-transactions`, requestOptions)
  .then((response) => response.json())
  .then((result) => {
    if(result.success == true){
      setGame(result?.data.transactions)
    }
  })
  .catch((error) => console.error(error));
      } catch (error) {
        
      }
    }
    useEffect(()=>{
      GetDepositApi();
      GetGameTrans();
    },[])

    const Navigate= useNavigate()
  useEffect(() => { 
    if(!localStorage.getItem('token')){ 
        Navigate("/") 
    }
  }, [])
  return (
    <div>

        <div className='container mt-5 pt-4 '>
            <div className='row'>
                <div className='col-lg-12 col-sm-12'>

                <div style={{ display: "flex", justifyContent: "space-around", marginBottom: "20px" }}>
        {["Payment", "Game", "Refferal"].map((tab) => (
          <button
            key={tab}
            className="btn"
            onClick={() => handleTabClick(tab)}
            style={{
              border: "1px solid #ddd",
              borderRadius: "20px",
              padding: "10px 20px",
              backgroundColor: activeTab === tab ? "#007bff" : "white",
              color: activeTab === tab ? "white" : "black",
              cursor: "pointer",
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div style={{ padding: "8px",   borderRadius: "10px",height:'70vh', overflow:"scroll" }}>
        {activeTab === "Payment" && <div> 
          {
    Data && Data?.length > 0 ? (
    Data.map((res) => {
      return (
        <div className="card mt-3 abcd"   style={{boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'}} >
          <div className="card-body">
            <div style={{display:'flex', justifyContent:'space-around'}}>
            <h6 style={{fontSize:'15px'}}>Amount: {res.amount}</h6> 
            <h6 style={{fontSize:'15px'}}>Date: {formatDate(res.created_at)}</h6>
            </div>
            <h6 className='pt-2 text-center' style={{fontSize:'15px'}}>Transaction Id: {res.txn_id}</h6>
          </div>
        </div>
      );
    })
  ) : (
    <div className="no-data" style={{height:'65vh'}}>
      <div className='mt-5 pt-5'  style={{display:'flex', justifyContent:'center'}}>
              <img src={not} alt='' style={{width:'50%'}}/>
            </div>

            <h5 className='text-center mt-4'>No transaction History            </h5>
            <p className='text-center'>You have not made any transaction yet.</p>
            
            </div>
  )
}
            
            </div>}


        {activeTab === "Game" && 
        
        <div>


<div  style={{height:'70vh', overflow:"scroll"}}>
  {game?.length > 0 ? (
    game.map((res, index) => (
      <div
        key={index}
        className="card mt-2 abcd"
        style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
      >
        <div className="card-body">
          <div>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <h6 style={{ fontSize: "14px" }}>Date: {formatDate(res.created_at)}</h6>
              <h6 style={{ fontSize: "14px" }}>Amount: {res?.amount}</h6>
            </div>
            <h6 style={{ fontSize: "14px" }} className="text-center pt-1">
              Description: {res?.description}
            </h6>
          </div>
        </div>
      </div>
    ))
  ) : (
    <div className="mt-5 pt-5" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <img src={nogame} alt="No Game History" style={{ width: "50%" }} />
      <h5 className="text-center mt-4">No Game History</h5>
      <p className="text-center">You have no game history yet.</p>
    </div>
  )}
</div>

          



            
    
            </div>
        
        }
        {activeTab === "Refferal" && <div>
            <div className='mt-5 pt-5'  style={{display:'flex', justifyContent:'center'}}>
              <img src={not} alt='' style={{width:'50%'}}/>
            </div>

            <h5 className='text-center mt-4'>No Refer History
            </h5>
            <p className='text-center'>You have not made any refers yet.

</p>
            </div>}
      </div>


                     
                </div>
            </div>
        </div>
    </div>
  )
}

export default TransactionHistory